import React, { Component } from 'react';
import './Layout';

class Interests extends Component {
    render(){
        return(
            <div className="w-100">
                <h2 className="mb-5">Interests</h2>
                <p>
                    Apart from video game design and programming and being an avid puruser of strategy game titles
                    I am a massive fan of table top rpgs, everything from Dungeons and Dragons to Powered by the 
                    Apocalypse titles. I'm even in the process of designing one of my own!
                </p>
                <p className="mb-0">
                    I'm a bit of a foodie, probably from the 15 years spent as a chef, and when not cooking up a storm
                    (or cleaning up afterwards), I spend my free time sating my appetite for learning new skills 
                    and technologies
                </p>
            </div>
        );
    }
}

export default Interests